import api from 'api'
import type { AxiosRequestConfig } from 'axios'

import { validateApiResponse } from 'utils/validateApiResponse'

import { REQUEST_ACTIVITY_MAX_PER_PAGE, REQUEST_ACTIVITY_PATHS } from './paths'
import { reviewActivityListResponseSchema } from './schemas'
import type { GetRequestActivityParams, ReviewActivityListResponse } from './types'

export const getRequestActivity = async (
  { requestType, requestId, page = 1, perPage = REQUEST_ACTIVITY_MAX_PER_PAGE }: GetRequestActivityParams,
  options?: AxiosRequestConfig
): Promise<ReviewActivityListResponse> => {
  const { data } = await api.get<ReviewActivityListResponse>(REQUEST_ACTIVITY_PATHS[requestType](requestId), {
    ...options,
    params: { page, perPage, ...options?.params }
  })

  return validateApiResponse(reviewActivityListResponseSchema, data)
}
